import React, { useState, useEffect } from "react";
import { useAuthUser } from "react-auth-kit";
import { useServerApi } from "../hooks/useServerApi";
import { useTranslation } from "react-i18next";
import "to-color-string";
import _ from "lodash";
import {
  Text,
  Accordion,
  Group,
  ActionIcon,
  Badge,
  Title,
  Box,
  Divider,
} from "@mantine/core";
import { useCellRender } from "../hooks/useCellRender";
import moment from "moment";
import { IconBox, IconGift, IconMoneybag } from "@tabler/icons-react";
import { useWindowScroll } from "@mantine/hooks";
import InfiniteScroll from "react-infinite-scroll-component";
import "to-color-string";

const CommissionItem = ({ item }) => {
  const { t } = useTranslation();
  const [cellRender] = useCellRender();

  return (
    <Accordion.Item key={item._id} value={item._id} bg="white">
      <Accordion.Control>
        <Group align="flex-start" justify="space-between">
          <Group align="flex-start">
            <span>
              <Group gap="2">
                <Badge radius={5} size="xs" color={item.status.toColorString()}>
                  {t(item.status)}
                </Badge>
                <Badge radius={5} size="xs" color={item.type.toColorString()}>
                  {t(item.type)}
                </Badge>
                <Badge radius={5} size="xs" color={item.type.toColorString()}>
                  {t(item.level)}
                </Badge>
              </Group>
              <Text size="xs">{item.code}</Text>
              <Group>
                <Text c="dimmed" size="xs">
                  {moment(item.paymentDate).format("YYYY-MM-DD HH:mm")}
                </Text>
              </Group>
              <Text size="xs"> {item?.product?.name} </Text>
            </span>
          </Group>
          <span>
            <Text fw={700} size="xs">
              {cellRender.Currency(item.amount)}
            </Text>
            <Text size="xs" c={"dimmed"}>
              {moment(item.createdAt).format("YYYY-MM-DD")}
            </Text>
          </span>
        </Group>
      </Accordion.Control>
      <Accordion.Panel>
        <Text size="xs" c={"dimmed"}>
          {t("Order")}: {item.order?.code}
        </Text>
        <Text size="xs" c={"dimmed"}>
          {t("Product")} : {item.order?.productSnapshot?.name}
        </Text>
        <Text size="xs" c={"dimmed"}>
          {t("Order Date")}: {item.order?.paymentDate}
        </Text>
        <Text size="xs" c={"dimmed"}>
          {t("Client")}: {item.order?.client?.name}
        </Text>
      </Accordion.Panel>
    </Accordion.Item>
  );
};
const Commissions = () => {
  const authUser = useAuthUser();
  const userId = authUser()._id;
  const [api] = useServerApi();
  const [commissions, setCommissions] = useState([]);
  const { t } = useTranslation();

  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  /**
   *
   * @param {*} userId
   */
  const fetch = async () => {
    try {
      if (!userId) return;
      //   console.log("fetchOrders", currentPage);
      const result = await api.search({
        apiEntity: "commission",
        currentPage,
        pageSize: 50,
        searchQuery: { client: userId },
      });

      if (!result || !result.docs) return;
      setCommissions((prev) => _.uniqBy([...prev, ...result.docs], "_id"));
      setTotal(result.total);
      setCurrentPage(currentPage + 1);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (!userId) return;
    fetch();
  }, [userId]);

  return (
    <>
      <Group
      // style={{
      //   position: "sticky",
      //   top: 50,
      //   background: "white",
      //   zIndex: 100,
      // }}
      >
        <Title order={4}>{t("My Commissions")}</Title>
        <Badge color="gray">{total}</Badge>
        {/* <Badge color="gray">{orders.length}</Badge> */}
      </Group>
      <InfiniteScroll
        dataLength={commissions.length} //This is important field to render the next data
        next={fetch}
        hasMore={commissions.length < total}
        endMessage={
          <Text ta="center" mt="xl" c="dimmed">
            {t("No more items")}
          </Text>
        }
        loader={<h4>Loading...</h4>}
      >
        <Accordion mt="md" variant="separated" multiple={true} chevron={null}>
          {commissions.map((item) => (
            <CommissionItem key={item._id} item={item} />
          ))}
        </Accordion>
      </InfiniteScroll>
    </>
  );
};

export default Commissions;
